import styled from "styled-components";
import {
  LAYOUT_MAX_WIDTH,
  MOBILE_BREAKPOINT,
  THEME,
} from "../../../utility/constants";
import { color } from "../Color/colors";

const { VODAFONE, SYN, STOD2 } = THEME;

export const SynBannerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const SynInnerContainer = styled.div`
  display: flex;
  margin: 8px 16px;
  background-color: rgb(247 247 247);
  border-radius: 28px;
  padding: 16px;
  height: 52px;
  box-shadow: 0 29px 64px 0 #D1001F1A, 0 116px 116px 0 #D1001F17, 0 262px 157px 0 #D1001F0D, 0 465px 186px 0 #D1001F03, 0 727px 203px 0 #D1001F00;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1224px;
`;

export const BannerContainer = styled.div`
  display: flex;
  width: 100%;
  height: ${(props) => (props.theme === VODAFONE ? "80px" : "100px")};
  justify-content: center;
  align-items: center;
  background: ${(props) =>
    props.theme !== STOD2 ? color.white : color.black};
  color: ${(props) => (props.theme !== STOD2 ? color.black : color.white)};
  margin-bottom: ${(props) => (props.theme !== STOD2 ? "3px" : "0px")};
  box-shadow: ${(props) =>
    props.theme !== STOD2 ? "0 2px 3px 0 rgba(0,0,0,0.2)" : "none"};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: 64px;
  }
`;

export const BannerInnerContainer = styled.div`
  display: flex;
  max-width: ${LAYOUT_MAX_WIDTH};
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const BannerImage = styled.img`
  height: ${(props) => (props.theme === SYN ? "50px" : props.theme !== STOD2 ? "46px" : "42px")};
  width: ${(props) => (props.theme === SYN ? "100px" : props.theme !== STOD2 ? "46px" : "74.52px")};

  @media (max-width: 1300px) {
    margin-left: ${(props) => (props.theme === SYN ? '' : '48px')};
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: ${(props) => (props.theme !== SYN ? "50px" : (props.theme !== STOD2 ? "46px" : "64px"))};
    margin-left: ${(props) => (props.theme === SYN ? "" : "20px")};
  }

  :hover {
    cursor: pointer;
  }
`;
